import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  Briefcase,
  CalendarPlus,
  FilePlus,
  Layers,
  Package,
  PlusCircle,
  ShoppingCart,
  UserPlus,
  type LucideIcon,
} from 'lucide-react';

import { cn } from '@/shared/lib/utils';

interface QuickAction {
  icon: LucideIcon;
  label: string;
  href: string;
  accent:
    | 'tw-bg-primary/10 tw-text-primary group-hover:tw-bg-primary group-hover:tw-text-primary-foreground'
    | 'tw-bg-success/10 tw-text-success group-hover:tw-bg-success group-hover:tw-text-success-foreground'
    | 'tw-bg-warning/10 tw-text-warning group-hover:tw-bg-warning group-hover:tw-text-warning-foreground'
    | 'tw-bg-secondary/10 tw-text-secondary group-hover:tw-bg-secondary group-hover:tw-text-secondary-foreground';
}

const ACTIONS: QuickAction[] = [
  {
    icon: PlusCircle,
    label: 'New Work Order',
    href: '/clients/work-orders/create',
    accent: 'tw-bg-primary/10 tw-text-primary group-hover:tw-bg-primary group-hover:tw-text-primary-foreground',
  },
  {
    icon: FilePlus,
    label: 'Create Quote',
    href: '/quotes/create',
    accent: 'tw-bg-success/10 tw-text-success group-hover:tw-bg-success group-hover:tw-text-success-foreground',
  },
  {
    icon: CalendarPlus,
    label: 'Schedule Meeting',
    href: '/meetings/create',
    accent: 'tw-bg-warning/10 tw-text-warning group-hover:tw-bg-warning group-hover:tw-text-warning-foreground',
  },
  {
    icon: UserPlus,
    label: 'Add Client',
    href: '/clients/create',
    accent: 'tw-bg-secondary/10 tw-text-secondary group-hover:tw-bg-secondary group-hover:tw-text-secondary-foreground',
  },
  {
    icon: Briefcase,
    label: 'Add Lead',
    href: '/leads/create',
    accent: 'tw-bg-primary/10 tw-text-primary group-hover:tw-bg-primary group-hover:tw-text-primary-foreground',
  },
  {
    icon: Package,
    label: 'Add Product',
    href: '/products/create',
    accent: 'tw-bg-success/10 tw-text-success group-hover:tw-bg-success group-hover:tw-text-success-foreground',
  },
  {
    icon: Layers,
    label: 'View Inventory',
    href: '/products/list',
    accent: 'tw-bg-secondary/10 tw-text-secondary group-hover:tw-bg-secondary group-hover:tw-text-secondary-foreground',
  },
  {
    icon: ShoppingCart,
    label: 'Purchase Orders',
    href: '/purchase-orders/list',
    accent: 'tw-bg-warning/10 tw-text-warning group-hover:tw-bg-warning group-hover:tw-text-warning-foreground',
  },
];

/**
 * Bottom-of-page quick actions strip for the Operations Command Center.
 */
export function AdminQuickActions() {
  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-3 sm:tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-8">
      {ACTIONS.map((action) => {
        const Icon = action.icon;
        return (
          <Link
            key={action.href + action.label}
            to={action.href}
            className="tw-group tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-bg-card tw-px-3 tw-py-4 tw-text-center tw-text-sm tw-text-foreground tw-no-underline tw-shadow-sm tw-transition-all hover:tw-border-primary/40 hover:tw-shadow-md focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2"
          >
            <span
              className={cn(
                'tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-transition-colors',
                action.accent,
              )}
            >
              <Icon className="tw-h-5 tw-w-5" />
            </span>
            <span className="tw-text-xs tw-font-medium">{action.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
